// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled from 'styled-components';

export const AnimatedWrapper = styled.div<{
  open?: boolean;
}>`
  opacity: 0;
  transform: translateY(150px);
  transition: transform 0.35s ease-in-out, opacity 0.35s ease-in-out;
  box-shadow: 0px 0px 12px rgba(227, 228, 229, 0.5),
    0px 0px 4px rgba(187, 188, 191, 0.16);
  ${props => {
    if (props.open) {
      return `
      opacity: 1;
      transform: translateY(0px);
      `;
    }
  }}
`;
